import { render, staticRenderFns } from "./modal-user-recuperar-senha.vue?vue&type=template&id=58fb30ce&scoped=true&"
import script from "./modal-user-recuperar-senha.vue?vue&type=script&lang=js&"
export * from "./modal-user-recuperar-senha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fb30ce",
  null
  
)

export default component.exports